export default __webpack_public_path__ + "static/transformImg2-c10ae1f7990da8383076cc2ec1b443ee.png";